<template>
  <v-radio-group v-bind="this.$attrs" v-model="type" @change="handleChange" row class="shrink mt-0 pt-0">
    <v-row style="width: 100%">
      <v-col cols="12" sm="3">
        <v-radio label="Có mặt" hide-details :value="true"></v-radio>
      </v-col>
      <v-col cols="12" sm="3">
        <v-radio label="Vắng mặt" hide-details :value="false"></v-radio>
      </v-col>
    </v-row>
  </v-radio-group>
</template>

<script>
export default {
  data: () => ({
    type: '',
  }),
  props: {
    item: {
      type: Object,
    },
  },
  created() {
    if (this.item) {
      this.type = this.item.present
    }
  },
  watch: {
    item(newVal) {
      if (newVal) {
        this.type = newVal.present
      }
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value)
    },
  },
}
</script>
